import styled from "styled-components";

const Wrapper = styled.nav`
    position : relative;
    margin : 0 30px 0 30px;
    @media screen and (max-width: 1000px) {
        display : none;
    }
    a.title{
        position: absolute;
        font-weight: 600;
        top: 18px;
        font-size: 12px;
        color : #000;
        z-index : 1;
        &:hover{
            color : #2251ff;
        }
    }
    ul{
        list-style: none;
        display : flex;
        margin : 0;
        gap : 20px;
        li a{
            border-bottom : solid 4px #fff;
            color : #333 !important;
            padding : 0px;
            font-family: "McKinsey Sans Light";
            text-transform: none;
            height : 86px;
            display : inline-block;
            line-height : 110px;
            white-space: nowrap;
            cursor : pointer;
            font-weight : 300;
            &.active{
                color : #2251FF !important;
                border-bottom : solid 4px #2251FF;
            }
            position : relative;
            ul{
                position : absolute;
                z-index : 11;
            }
            &:hover{
                color : #2251FF;
                ul{
                    display : block !important;
                    background : #fff;
                    border : solid thin #ccc;
                    top : calc(100% + 4px);
                    width : 100%;
                    li{
                        height : auto;
                        padding : 10px;
                        color : #6c6c6c;
                        line-height : 1rem;
                        border : none;
                        &:hover{
                            color : #2251ff;
                        }
                    }
                }
            }
        }
    }
`

export default Wrapper